// extracted by mini-css-extract-plugin
export default {"audio_player_head_controls":"b31ddf"};